import { Component } from "@angular/core";
import { RequestsAndOperations } from "@edp-models/requests-and-operations";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { INewRequestAndOperation, NewRequestService } from "@edp-pages/requests-and-operations/services/new-request.service";
import { StepsService } from "@edp-pages/requests-and-operations/services/steps.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { getSelectedRequest } from "@edp-store/selectors/requests-and-operations.selector";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "create-request-sidebar",
    templateUrl: "./create-request-modal-sidebar.component.html",
    styleUrls: ["./create-request-modal-sidebar.component.scss"],
})
export class CreateRequestModalSidebarComponent {
    public step$: BehaviorSubject<number>;
    public steps$: Observable<number[]>;
    public motiveName: string;
    public selfcare = false;

    constructor(
        private readonly stepsService: StepsService,
        private readonly newRequestService: NewRequestService,
        private readonly newModalService: NewModalService,
        private readonly store: Store<IAppState>,
        private edpPaymentAgreementService: EdpPaymentAgreementService
    ) {
        this.step$ = this.stepsService.getCurrentStep();
        this.steps$ = this.stepsService
            .getSteps()
            .pipe(map(steps => (steps.length > 3 ? steps.slice(steps.length - 3, steps.length) : steps)));
        combineLatest([this.newRequestService.getRequestAndService(), this.store.select(getSelectedRequest)]).subscribe(
            ([newRequest, selectedRequest]: [INewRequestAndOperation, RequestsAndOperations]) => {
                this.selfcare = newRequest ? ["edp.pt", "edponline"].includes(newRequest.selectedMotive.selfcare) : false;
                this.motiveName = newRequest ? newRequest.selectedMotive.name : selectedRequest?.Motive;
            }
        );
    }

    public backStep() {
        this.stepsService.removeStep();
        this.stepsService.backStep();
        this.stepsService.setAdvanceStepButtonAvailability(false);
        this.edpPaymentAgreementService.onKillWaitingVerification();
        this.edpPaymentAgreementService.setHeight(false);
    }

    public closeModal() {
        this.newModalService.closeModal();
        this.stepsService.resetStep();
    }
}
